<script>
import ComparatifCta from "./carte-fidelite-comparatif-cta";
import Icon from "@/components/atoms/icon";

export default {
  name: "CartesFideliteComparatif",
  components: { ComparatifCta, Icon },
  emits: ["addCard"]
};
</script>

<template>
  <div class="c-cartes-fidelite-comparatif u-bgcolor-white u-radius-lg">
    <div class="c-cartes-fidelite-comparatif__header">
      <div class="c-cartes-fidelite-comparatif__header-cover" />
    </div>
    <table class="c-cartes-fidelite-comparatif__table">
      <thead>
        <tr>
          <th
            valign="bottom"
            colspan="2"
          >
            <caption class="u-block u-text-left u-font-24 u-font-700 u-font-secondary u-mb-xlg">
              Des avantages<br> qui répondent à vos envies&nbsp;!
            </caption>
          </th>
          <th
            scope="col"
            valign="top"
            align="center"
          >
            <ComparatifCta
              type-carte="Malin"
              class="c-carte-fidelite-comparatif-cta--top u-mb-lg20"
            />
          </th>
          <th
            scope="col"
            valign="top"
            align="center"
          >
            <ComparatifCta
              type-carte="Cora"
              class="c-carte-fidelite-comparatif-cta--top u-mb-lg20"
            />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th
            colspan="4"
            align="left"
          >
            <p class="u-font-17 u-font-500">
              Cumul de points fidélité
            </p>
          </th>
        </tr>
        <tr>
          <td
            scope="row"
            colspan="2"
          >
            <p class="u-font-14">
              1€ dépensé en magasin = 1 point fidélité
            </p>
          </td>
          <td align="center">
            <Icon
              name="check"
              variant="primary"
              aria-label="Compris dans l'offre"
            />
          </td>
          <td align="center">
            <Icon
              name="check"
              variant="primary"
              aria-label="Compris dans l'offre"
            />
          </td>
        </tr>
        <tr>
          <td
            scope="row"
            colspan="2"
            class="u-border-none"
          >
            <p class="u-font-14">
              5 points fidélité pour toute transaction au carburant
            </p>
          </td>
          <td
            align="center"
            class="u-border-none"
          >
          </td>
          <td
            align="center"
            class="u-border-none"
          >
            <Icon
              name="check"
              variant="primary"
              aria-label="Compris dans l'offre"
            />
          </td>
        </tr>
        <tr>
          <th
            colspan="4"
            align="left"
          >
            <p class="u-font-17 u-font-500">
              Cumul d'€urocora
            </p>
          </th>
        </tr>
        <tr>
          <td
            scope="row"
            colspan="2"
          >
            <p class="u-font-14">
              Des réductions sur les produits en catalogues
            </p>
          </td>
          <td align="center">
            <Icon
              name="check"
              variant="primary"
              aria-label="Compris dans l'offre"
            />
          </td>
          <td align="center">
            <Icon
              name="check"
              variant="primary"
              aria-label="Compris dans l'offre"
            />
          </td>
        </tr>
        <tr>
          <td
            scope="row"
            colspan="2"
            class="u-border-none"
          >
            <p class="u-font-14">
              10% de remise sur les produits cora le mercredi ou le jeudi
            </p>
          </td>
          <td
            align="center"
            class="u-border-none"
          >
          </td>
          <td
            align="center"
            class="u-border-none"
          >
            <Icon
              name="check"
              variant="primary"
              aria-label="Compris dans l'offre"
            />
          </td>
        </tr>
        <tr>
          <th
            colspan="4"
            align="left"
          >
            <p class="u-font-17 u-font-500">
              Des promotions exclusives
            </p>
          </th>
        </tr>
        <tr>
          <td
            scope="row"
            colspan="2"
            class="u-border-none"
          >
            <p class="u-font-14">
              Recevez des offres par courrier, sms ou e-mail à valoir dans votre magasin cora
            </p>
          </td>
          <td
            align="center"
            class="u-border-none"
          >
            <Icon
              name="check"
              variant="primary"
              aria-label="Compris dans l'offre"
            />
          </td>
          <td
            align="center"
            class="u-border-none"
          >
            <Icon
              name="check"
              variant="primary"
              aria-label="Compris dans l'offre"
            />
          </td>
        </tr>
        <tr>
          <th
            colspan="4"
            align="left"
          >
            <p class="u-font-17 u-font-500">
              Des remises chez nos partenaires
            </p>
          </th>
        </tr>
        <tr>
          <td
            scope="row"
            colspan="2"
          >
            <p class="u-font-14">
              10 % de remise chez Azureva Vacances
            </p>
          </td>
          <td align="center">
            <Icon
              name="check"
              variant="primary"
              aria-label="Compris dans l'offre"
            />
          </td>
          <td align="center">
            <Icon
              name="check"
              variant="primary"
              aria-label="Compris dans l'offre"
            />
          </td>
        </tr>
        <tr>
          <td
            scope="row"
            colspan="2"
            class="u-border-none"
          >
            <p class="u-font-14">
              Profitez de remises immédiates ou d'offres de remboursement via le programme Avantages Cpay
            </p>
          </td>
          <td
            align="center"
            class="u-border-none"
          >
          </td>
          <td
            align="center"
            class="u-border-none"
          >
            <Icon
              name="check"
              variant="primary"
              aria-label="Compris dans l'offre"
            />
          </td>
        </tr>
        <tr>
          <th
            colspan="4"
            align="left"
          >
            <p class="u-font-17 u-font-500">
              Facilitez votre passage en caisse
            </p>
          </th>
        </tr>
        <tr>
          <td
            scope="row"
            colspan="2"
          >
            <p class="u-font-14">
              Gagnez du temps avec l'accès à la caisse prioritaire carte cora
            </p>
          </td>
          <td align="center">
          </td>
          <td align="center">
            <Icon
              name="check"
              variant="primary"
              aria-label="Compris dans l'offre"
            />
          </td>
        </tr>
        <tr>
          <td
            scope="row"
            colspan="2"
            class="u-border-none"
          >
            <p class="u-font-14">
              Corascan, profitez de scannettes pour des courses faciles et rapides
            </p>
          </td>
          <td
            align="center"
            class="u-border-none"
          >
            <Icon
              name="check"
              variant="primary"
              aria-label="Compris dans l'offre"
            />
          </td>
          <td
            align="center"
            class="u-border-none"
          >
            <Icon
              name="check"
              variant="primary"
              aria-label="Compris dans l'offre"
            />
          </td>
        </tr>
        <tr>
          <th
            colspan="4"
            align="left"
          >
            <p class="u-font-17 u-font-500">
              Gestion de son budget
            </p>
          </th>
        </tr>
        <tr>
          <td
            scope="row"
            colspan="2"
          >
            <p class="u-font-14">
              Solutions de paiement toute l'année
            </p>
          </td>
          <td align="center">
          </td>
          <td align="center">
            <Icon
              name="check"
              variant="primary"
              aria-label="Compris dans l'offre"
            />
          </td>
        </tr>
        <tr>
          <td
            scope="row"
            colspan="2"
            class="u-border-none"
          >
            <p class="u-font-14">
              Vos tickets de caisse dématérialisés
            </p>
          </td>
          <td
            align="center"
            class="u-border-none"
          >
            <Icon
              name="check"
              variant="primary"
              aria-label="Compris dans l'offre"
            />
          </td>
          <td
            align="center"
            class="u-border-none"
          >
            <Icon
              name="check"
              variant="primary"
              aria-label="Compris dans l'offre"
            />
          </td>
        </tr>
        <tr>
          <th
            colspan="4"
            align="left"
          >
            <p class="u-font-17 u-font-500">
              Des garanties & assurances supplémentaires
            </p>
          </th>
        </tr>
        <tr>
          <td
            scope="row"
            colspan="2"
          >
            <p class="u-font-14">
              Garantie livraison internet : vous êtes couverts en cas de non livraison ou livraison non conforme de vos achats neufs
            </p>
          </td>
          <td align="center">
          </td>
          <td align="center">
            <Icon
              name="check"
              variant="primary"
              aria-label="Compris dans l'offre"
            />
          </td>
        </tr>
        <tr>
          <td
            scope="row"
            colspan="2"
            class="u-border-none"
          >
            <p class="u-font-14">
              Assurance voyage : vivez plus sereinement tous les aléas de voyage en bénéficiant de multiples garanties
            </p>
          </td>
          <td
            align="center"
            class="u-border-none"
          >
          </td>
          <td
            align="center"
            class="u-border-none"
          >
            <Icon
              name="check"
              variant="primary"
              aria-label="Compris dans l'offre"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/carte-fidelite-comparatif.scss";
</style>
